import { render, staticRenderFns } from "./TasksTable.vue?vue&type=template&id=21968190&scoped=true&"
import script from "./TasksTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./TasksTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TasksTable.vue?vue&type=style&index=0&id=21968190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21968190",
  null
  
)

export default component.exports